import { createAuthClient } from "better-auth/react";
import { adminClient, emailOTPClient, organizationClient } from "better-auth/client/plugins";
import type { AuthClient } from "shared/features/auth";
import { apiFetch } from "./rateLimitNotice";

// No `baseURL` — better-auth requires it to be a fully-qualified origin (it
// runs `new URL()` on it), so a relative path throws synchronously. Passing
// only `basePath` lets it fall back to `window.location.origin`, which is
// correct for same-origin requests through the /api dev proxy (and for any
// future same-origin deployment).
// adminClient: 서버 admin 플러그인과 짝. 지금은 세션 user 의 role 을 읽어 관리자
// 여부를 판단하는 데만 쓰고, 관리자 API(listUsers/setRole 등)는 향후 확장분이다.
// emailOTPClient: 서버 emailOTP 플러그인과 짝. 가입 시 인증 코드 발송/검증
// (authClient.emailOtp.*)에 쓴다 — pages/verify-email 참고.
// organizationClient: 서버 organization 플러그인과 짝. 팀 초대 생성/조회/수락
// (authClient.organization.*)에 쓴다 — pages/team-members, pages/invite 참고.
// 반환 타입은 아래 `AuthClient` 로 캐스팅되므로 zod v4 내부 타입(TS2742) 은 새지 않는다.
export const authClient = createAuthClient({
  basePath: "/api/auth",
  // 로그인/OTP 발송/비밀번호 재설정 등 인증 요청도 429 감지 래퍼로 감싼다 —
  // 서버 rate limit(RL_SENSITIVE·better-auth 내장)에 걸리면 안내 토스트를 띄운다.
  fetchOptions: { customFetchImpl: apiFetch },
  plugins: [adminClient(), emailOTPClient(), organizationClient()],
}) as unknown as AuthClient;
